import React, { Component } from 'react';
import { Container, Col, Row, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { EventContainer } from './EventNotificationContainer';
import  Calendar  from './Calendar'
import  InfoPanel  from './InfoPanel'
import  NotificationsDesk  from './NotificationsDesk'
import NotificationsChart from './NotificationsChart'



import { useSelector, useDispatch } from 'react-redux'
import { decrement, increment } from './redux/counterSlice'



export default class Home extends Component {
  static displayName = Home.name;


    constructor(props) {
        super(props); 
    }

    render() {

        return (


            <Container className="m-0 p-0 h-100" fluid>
                <Row className="p-0 m-0 h-100">
                    <Col sm={7} className="p-0 m-0 h-100">
                        <div className="d-flex flex-column h-100">
                            <Calendar />
                        </div>
                    </Col>
                    <Col sm={5} className="d-flex flex-column m-0 ps-2 p-0 h-100 ">
                        <Row className="m-0 p-0">
                            <Col className="m-0 p-0">
                                <InfoPanel />
                            </Col>
                        </Row>
                        <Row className="m-0 p-0">
                            <Col className="col-sm m-0 p-0 ">
                                <NotificationsChart />
                            </Col>
                        </Row>
                        {/*<Row className="m-0 p-0 flex-grow-1">
                            <Col className="d-flex flex-column col-auto m-0 p-0 ">
                                <NotificationsDesk />
                            </Col>
                        </Row>*/}
                    </Col>
                </Row>
            </Container>
    );
  }
};





